import type { AdminV2ComputedResolverDefinition } from '../tool-runtime-registries';
import { resolveAdminV2RequiredSingleImage } from './required-image-input';

function resolveImageEditingInput(normalizedInput: Record<string, unknown>) {
  return resolveAdminV2RequiredSingleImage({
    normalizedInput,
    fieldId: 'image',
    errorCode: 'ADMIN_V2_TOOL_IMAGE_EDITING_IMAGE_MISSING',
    message: 'This image editing tool requires one source image.',
  });
}

function resolveGptImageProviderInput(
  normalizedInput: Record<string, unknown>
) {
  return {
    image_urls: [resolveImageEditingInput(normalizedInput)],
    size: 'auto',
    resolution: '1k',
    quality: 'low',
    n: 1,
  };
}

export const imageEditingComputedResolverDefinitions = {
  imageEditingGptImageOfficialProviderInput: {
    outputType: 'json',
    resolver: ({ normalizedInput }) => ({
      ...resolveGptImageProviderInput(normalizedInput),
      moderation: 'low',
      output_format: 'png',
    }),
  },
  imageEditingGptImageExtendedProviderInput: {
    outputType: 'json',
    resolver: ({ normalizedInput }) => ({
      ...resolveGptImageProviderInput(normalizedInput),
      official_fallback: false,
    }),
  },
  imageEditingFluxProviderInput: {
    outputType: 'json',
    resolver: ({ normalizedInput }) => ({
      images: [resolveImageEditingInput(normalizedInput)],
      aspect_ratio: 'match_input_image',
      output_megapixels: '1',
      output_format: 'png',
      output_quality: 100,
      disable_safety_checker: true,
    }),
  },
} satisfies Record<string, AdminV2ComputedResolverDefinition>;
